import { SystemStatus } from 'javascripts/system-status.module';
import * as rx from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

var getHeaders = {
  'Accept': 'application/json'
};

var postHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

/**
 * @class
 */
export class UserService {

  /** @type {rx.BehaviorSubject<import('types/api').V1.UserFromAPI | null>} */
  _userSubject = new rx.BehaviorSubject(null);

  user$ = this._userSubject.pipe(distinctUntilChanged());
  isAuthenticated$ = this.user$.pipe(
    map(_ => !!_),
    distinctUntilChanged(),
  );
  state$ = this.user$.pipe(
    map(_ => _?.state ?? null),
    distinctUntilChanged(),
  );

  /**
   * @param {import("types/api").V2.FetchFastlinkStrategy.Request} args
   * @return {angular.IPromise<SheetsAPIV2Def.Schemas.FastlinkStrategy>}
   */
  fetchFastlinkInfo(args) {
    return this.$q.resolve(this.userGateway.getFastlinkInfo(args).$promise);
  };

  postFastlinkV3Success(success) {
    return this.$q.resolve(this.userGateway.postFastlinkV3Success(success).$promise);
  };

  fetchUser() {
    return this.$q.resolve(this.userGateway.get().$promise)
      .then(user => {
        this._userSubject.next(user);
        this.SystemStatusService.setComponentStatus('user', SystemStatus.Online);
        this._EventsService.start(user._id)
        // @ts-ignore
        this._$errorReporter.setUser(user._id);

        return user;
      }).catch(err => {
        if (err.status == 401) {
          // @todo:
          window.location.href = "https://www.tillerhq.com";
          return null;
        }

        this._$errorReporter(err);
        this._userSubject.next(null);
        this._EventsService.stop();
        this.SystemStatusService.setComponentStatus('user', SystemStatus.Offline);

        return null;
      });
  }

  updateOBQAnswers(results) {
    return Promise
      .resolve(this.userGateway.updateOBQAnswers(results).$promise)
      .then(() => this.fetchUser())
  }

  /**
   * @param {import("types/api").V1.UserFromAPI['state'][]} states
   * @return {boolean}
   */
  inAnyState(states) {
    return states.indexOf(this._userSubject.value?.state) != -1;
  }

  /** @type {import('../javascripts/events/events.service').EventsService} */
  _EventsService;

  /**
   * @param {import('api-services/user-resource.factory').IUserResource} UserResource
   * @param {ng.IQService} $q
   * @param {import('javascripts/system-status.module').SystemStatusService} SystemStatusService
   * @param {import('../javascripts/events/events.service').EventsService} EventsService
   * @param {import('stackdriver-errors-js').default['report']} $errorReporter
   */
  constructor(
    UserResource,
    $q,
    SystemStatusService,
    EventsService,
    $errorReporter,
  ) {
    this.userGateway = UserResource;
    this.$q = $q;
    this.SystemStatusService = SystemStatusService;
    this._EventsService = EventsService;
    this._$errorReporter = $errorReporter;

    this.SystemStatusService.addComponent('user');
  }
}

export default [
  'UserResource',
  '$q',
  'SystemStatusService',
  'EventsService',
  '$errorReporter',
  UserService,
];



